import React, { useState, useEffect, useRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import HC_exporting from 'highcharts/modules/exporting'
import ptBr from '@app/i18n/ptBR/index'
import { AreaExecutiveSummaryCurvaEconomicaResult } from '@app/api/areaExecutiveSummary';
import { ColumnProps, Table } from '@digital/ui';
import { formatCurrencyBr } from '@app/helpers/numbers';
HighchartsMore(Highcharts);
HC_exporting(Highcharts)

interface AreaExecutiveSummaryCurvaEconomicaProps {
    grafico: AreaExecutiveSummaryCurvaEconomicaResult,
}

const AreaExecutiveSummaryCurvaEconomica = ({ grafico }: AreaExecutiveSummaryCurvaEconomicaProps) => {
    const chartRef = useRef(null);
    const getColluns = () => {
        let col: ColumnProps<any>[] = new Array();

        col.push(
            {
                title: `nome`,
                dataIndex: `nome`,
            }
        )

        if (grafico && grafico.collunsTable) {
            grafico.collunsTable.forEach((coluna) => {
                col.push({
                    title: `${coluna.title}`,
                    dataIndex: `${coluna.dataIndex}`,
                    render: (text: any, record: any, index: number) => {
                        if (text == undefined || text == null) {
                            return ['']
                        }
                        return [<> {formatCurrencyBr(text)}</>];
                    }
                })
            });
        }

        return col;
    }

    const optionsColumn: Highcharts.Options = {
        chart: {
            zoomType: 'xy'
        },
        title: {
            text: ''
        },
        colors: ['#08340D', '#80BDA6', '#E1865C'],
        xAxis: {
            categories: grafico && grafico.categorias ? grafico.categorias : [],
            labels: {
                format: '{value}',
                style: {
                    color: Highcharts.getOptions().colors[1]
                }
            },
            title: {
                text: 'Meses',
                style: {
                    color: Highcharts.getOptions().colors[1]
                }
            }
        },
        yAxis: [
            {
                title: {
                    text: 'Valor Acumulado',
                    style: {
                        color: Highcharts.getOptions().colors[0]
                    }
                },
                labels: {
                    formatter: function () { return '' + this.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ''; },
                    style: {
                        color: Highcharts.getOptions().colors[0]
                    }
                },
                opposite: true
            },
            {
                labels: {
                    formatter: function () { return '' + this.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ''; },
                    style: {
                        color: Highcharts.getOptions().colors[1]
                    }
                },
                title: {
                    text: 'Valor Mensal',
                    style: {
                        color: Highcharts.getOptions().colors[1]
                    }
                }
            }
        ],
        tooltip: {
            formatter: function () { return '<b>' + this.y.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + '</b>'; }
        },
        series: grafico && grafico.series ? grafico.series : [],
    };



    return (

        <>

            <HighchartsReact
                ref={chartRef}
                highcharts={Highcharts}
                options={optionsColumn}
            />

            <Table
                columns={grafico && grafico.collunsTable ? getColluns() : []}
                dataSource={grafico ? grafico.tableDataSource : []}
                pagination={false}
            />
        </>

    );
}


export default AreaExecutiveSummaryCurvaEconomica;
